const WeeklyUpdatesContent = [
  {
    dates: {
      currentWeekEndDate: '07/13/2022 12:00:00 am'
    },
    holiday: {
      previewStart: '10/20/2021 12:00:00 am',
      start: '10/20/2021 12:00:00 am',
      thanksgivingEnd: '12/01/2021 12:00:00 am',
      christmasEnd: '',
      previewEnd: '12/28/2021 12:00:00 am',
      end: '01/05/2022 12:00:00 am'
    }
  }
]

module.exports = { WeeklyUpdatesContent }
